
import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material'

const UpArrowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 8" width="12" height="8" fill="none">
        <path fill="currentColor" d="M10 8H2a1 1 0 0 1-.8-1.6l4-5.33a1 1 0 0 1 1.6 0l4 5.33A1 1 0 0 1 10 8z"></path>
    </svg>
    );
};
const UpArrow: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} >
        {UpArrowIcon()}
    </SvgIcon>
)

export default UpArrow;